import React from "react";
import { motion } from "framer-motion";
import {
  FaHeartbeat,
  FaStethoscope,
  FaMedkit,
  FaProcedures,
} from "react-icons/fa";
import "./about.scss";
import Image1 from "../img/post.png";

import { Link } from 'react-router-dom'; // Ensure Link is imported for routing


const About = () => {
  return (
    <div className="about-page">
      
      <div className="container">
        {/* Welcome Section */}
        <motion.div
          className="heading-section"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          whileInView={{ opacity: 1, y: 0 }} // Trigger animation when in view
          viewport={{ once: true }} // Ensures it triggers only once
        >
          <h1 className="heading">
            <FaHeartbeat className="heading-icon" /> Welcome to Care Health Nurses Pvt. Ltd
          </h1>
        </motion.div>

        {/* About Content Section */}
        <motion.div
          className="about-content"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }} // Trigger animation when in view
          viewport={{ once: true }} // Ensures it triggers only once
          transition={{ duration: 1 }}
        >
          <div className="about-layout">
            <div className="image-section">
              <motion.img
                src={Image1}
                alt="Care Health Nurses"
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
                transition={{ duration: 1 }}
              />
            </div>
            <div className="text-section card">
              <motion.p
                className="intro"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
              >
                Care Health Nurses Pvt. Ltd. , established in 2018, is a leading nursing agency in India, offering personalized, safe, and affordable caretaker services. The company operates in Delhi, Noida, Lucknow, Kanpur, and Gaziabad providing a range of healthcare solutions, from elderly care to critical health management. Their professional team includes qualified male and female nurses, trained caregivers, and support staff, all committed to delivering exceptional care.
              </motion.p>
              <motion.p
                className="mission"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.4 }}
              >
                The company’s services include elderly care, where trained caregivers assist with mobility, medication, and hygiene; baby and mother care, providing support during postnatal recovery; and critical health management for patients needing specialized care like tracheostomy or gastrostomy. Additionally, Care Health Nurses offers general caregiving services, such as cooking, cleaning, and companionship.
              </motion.p>
              <motion.p
                className="mission"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.8 }}
              >
                Care Health Nurses Pvt. Ltd. has become a trusted partner in home healthcare, offering compassionate and expert care for clients across India.
              </motion.p>
              <motion.p
                className="mission"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.8 }}
              >
                For more details, you can contact them at +91–9999790231 or carehealthdigital@gmail.com.
              </motion.p>
           
            </div>
          </div>
        </motion.div>

        {/* Why Choose Us Section */}
        <motion.div
          className="why-choose-us"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }} // Trigger animation when in view
          viewport={{ once: true }} // Ensures it triggers only once
          transition={{ duration: 1 }}
        >
          <h2>
            <FaStethoscope className="why-icon" /> Why Choose Us?
          </h2>
          <div className="reasons">
            {[
              { title: "Complete Satisfaction", description: "Best attention and selfless care for the patients." },
              { title: "Experienced Attendants", description: "Experts in caring for bedridden patients, knee replacement, paralysis, and more." },
              { title: "Full Range of Services", description: "Comprehensive care for senior citizens and patients." },
              { title: "Advanced Equipment", description: "State-of-the-art equipment for quality patient care." },
            ].map((reason, index) => (
              <motion.div
                className="reason card"
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }} // Trigger animation when in view
                viewport={{ once: true }} // Ensures it triggers only once
                transition={{ delay: index * 0.2 }}
              >
                <h3>{reason.title}</h3>
                <p>{reason.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Special Services Section */}
        <motion.div
          className="special-services"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }} // Trigger animation when in view
          viewport={{ once: true }} // Ensures it triggers only once
          transition={{ duration: 1 }}
        >
          <h2>
           
            <FaHeartbeat className="special-service-icon" />   <Link to="/Services"> Our Special Services </Link>
          </h2>
          <ul>
            <li>
              <FaMedkit className="service-icon" /> <Link to="/Services/patientCare"> Patient Care Attendant</Link>
            </li>
            <li>
              <FaProcedures className="service-icon" /> <Link to="/Services/tracheostomy"> Tracheostomy Care Nurses </Link>
            </li>
            <li>
              <FaMedkit className="service-icon" /> ICU Care Attendant
            </li>
            <li>
              <FaHeartbeat className="service-icon" /> <Link to="/Services/HomePatientCare">Home Care</Link>
            </li>
          </ul>
        </motion.div>
      </div>
    </div>
  );
};

export default About;